import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";

const Pumpe = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);

  //========================================================================
  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(value.value));

  //========================================================================
  // Simulation
  let simulation = false;
  let simValue = 0;

  try {
    simulation = props.style.properties.simulation;
    simValue = props.style.properties.simValue;
  } catch (error) {
    simulation = false;
  }

  if (simulation) {
    idx = Math.abs(parseInt(simValue));
  }

  //========================================================================
  // Bilder laden
  const pathAus = require("../../images/controls/Pumpe/PumpeAus.png");
  const pathEin = require("../../images/controls/Pumpe/PumpeEin.gif");
  const pathSto = require("../../images/controls/Pumpe/PumpeSto.gif");
  const pathWarAus = require("../../images/controls/Pumpe/PumpeWarAus.gif");
  const pathWar = require("../../images/controls/Pumpe/PumpeWar.gif");

  let imagePath = pathAus;
  if (isFinite(idx)) {
    switch (idx) {
      case 0:
        imagePath = pathAus;
        break;
      case 1:
        imagePath = pathEin;
        break;
      case 2:
        imagePath = pathSto;
        break;
      case 3:
        imagePath = pathWarAus;
        break;
      case 4:
        imagePath = pathWar;
        break;
    }
  }

  return (
    <img
      style={{
        ...props.style,
        visibility: props.props.visibility,
      }}
      title={
        language.displayText(value.name) +
        (globalVars.cyclicUpdate || globalVars.editor
          ? "\n" + ("Variable: " + props.props.variable)
          : "")
      }
      src={imagePath}
    />
  );
});

export default Pumpe;
